import { crmLevel, hasCrm, seesAllCrm } from "../../../access";

/**
 * Nombres que el servidor todavía acepta en las rutas.
 * El acceso real lo decide la cuenta: admin ve el CRM sin ser crm_manager.
 */
export const CRM_ROLES = ["crm_manager", "crm_agent", "crm_marketer", "crm_qualifier"];

export const CRM_ADMIN_ROUTE = "/crm/admin";
export const CRM_EXECUTIVE_ROUTE = "/crm/ejecutivo";

export const CRM_FULL_ACCESS_ROLES = ["crm_manager"];
export const CRM_EXECUTIVE_ROLES = ["crm_manager", "crm_agent", "crm_marketer"];

export const canSeeAllLeads = (user) => seesAllCrm(user);
export const canAssignLeads = (user) => seesAllCrm(user);
export const canEnterCrm = (user) => hasCrm(user);
export const isCrmPerson = (user) => Boolean(crmLevel(user));
